// extracted by mini-css-extract-plugin
export var articlePageContainer = "f_t";
export var articlePostContainer = "f_v";
export var articlePostEditorial = "f_w";
export var articleSourcesContainer = "f_y";
export var customArticleCard = "f_z";
export var infoContainer = "f_s";
export var pageContent = "f_x";
export var relatedArticles = "f_B";